module.exports = __webpack_public_path__ + "static/media/opakowania_3_A.919ed5e3.png";